import { methods } from "../../utils/axios";

export default class UsersAdminApi {
    static createUsersAdmin(data) {
        return methods.post('/users/admin', data);
    }

    static listUsersByGroup(groupName) {
        return methods.get(`/users/group/${groupName}`);
    }

    static updateUsersAdmin(username, data) {
        return methods.put(`/users/${username}`, data);
    }

    static deleteUsersAdmin(username) {
        return methods.del(`/users/${username}`);
    }
}